import SearchIcon from '@mui/icons-material/Search';
import { Autocomplete, InputAdornment, SxProps, TextField } from '@mui/material';
import { useQuery } from '@parkchirp/api-client';
import { FC } from 'react';

import { LIST_VEHICLE_MODELS } from '../../queries';

export const ModelAutocomplete: FC<{
	make: {
		id: number;
		name: string;
	} | null;
	model: { id: number; name: string } | null;
	setModel: (model: { id: number; name: string } | null) => void;
	showLabel?: boolean;
	label?: string;
	sx?: SxProps;
	disabled?: boolean;
	size?: 'small' | 'medium';
}> = ({ make, model, setModel, sx, showLabel = true, label = 'Select Model', disabled = false, size = 'medium' }) => {
	const { data, loading } = useQuery<{
		listVehicleModels: {
			data: {
				id: number;
				name: string;
			}[];
		};
	}>(LIST_VEHICLE_MODELS, {
		variables: {
			vehicleMakeId: make?.id,
		},
		context: {
			apiVersion: 'v2',
			public: true,
		},
		skip: !make?.id,
	});

	return (
		<Autocomplete
			fullWidth
			size={size}
			options={data?.listVehicleModels?.data ?? []}
			getOptionLabel={(o) => o.name}
			loading={loading}
			renderInput={(params) => (
				<TextField
					{...params}
					label={showLabel ? label : undefined}
					InputProps={{
						...params.InputProps,
						startAdornment: (
							<>
								<InputAdornment position='start'>
									<SearchIcon />
								</InputAdornment>
								{params.InputProps.startAdornment}
							</>
						),
					}}
					placeholder='Search for Model'
				/>
			)}
			disabled={disabled || !make?.id}
			value={model}
			onChange={(_, newModel) => {
				setModel(newModel);
			}}
			{...(sx && { sx })}
		/>
	);
};
